import { Component } from '@angular/core';

@Component({
  selector: 'app-registration-modal',
  templateUrl: './registration-modal.component.html',
  styleUrl: './registration-modal.component.css'
})
export class RegistrationModalComponent {

}
